import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

interface Response<T = any> {
  success: boolean;
  data: T | null;
  error: string;
}

interface ApiRequestParams extends AxiosRequestConfig {
  endpoint: string;
}
const apiService = async <T = any>(
  params: ApiRequestParams
): Promise<Response<T> | Response> => {
  try {
    const token = localStorage.getItem("token");

    const config: AxiosRequestConfig = {
      url: `${process.env.REACT_APP_API_BASE_URL}${params.endpoint}`,
      method: params.method || "GET",
      headers: {
        "Content-Type": "application/json",
        ...(params.headers || {}),
        Authorization: `Bearer ${token}`,
      },
      ...params,
    };

    const response: AxiosResponse<T> = await axios.request<T>(config);
    return {
      success: true,
      data: response.data,
      error: "",
    };
  } catch (error: any) {
    return {
      success: false,
      data: null,
      error: error.response?.data?.errors || error.response?.data?.detail || "Ocurrió un error inesperado.",
    };
  }
};

export default apiService;
